import { useFeatureFlag } from '@newfront-insurance/admin-ui';

import { useChatOverlayContext } from '../contexts/chat-overlay-context';

export const NOVA_ANALYTICS_FEATURE_FLAG = 'nova-admin-dashboard';

export function useCanViewNovaAnalytics(): boolean {
  const isEnabled = useFeatureFlag(NOVA_ANALYTICS_FEATURE_FLAG, false);
  const { userUuid, isPublicMode } = useChatOverlayContext();
  const isLocalPreviewEnabled =
    // Next.js must inline these variables so this opt-in cannot enable the dashboard in production.
    // eslint-disable-next-line no-process-env
    process.env.NODE_ENV === 'development' && process.env.NEXT_PUBLIC_NOVA_ANALYTICS_PREVIEW === 'true';

  // Scope discovery and every analytics request remain authorized by the backend.
  return (isEnabled || isLocalPreviewEnabled) && !isPublicMode && Boolean(userUuid);
}
